"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 25c0 13.531-10.969 24.5-24.5 24.5S.5 38.531.5 25 11.469.5 25 .5 49.5 11.469 49.5 25z",
    fill: "#E02020",
    stroke: "#E02020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.436 30.577h1.798l.464-13.92h-2.726l.464 13.92zm.899 5.713c.87 0 1.595-.754 1.595-1.595a1.61 1.61 0 00-1.595-1.595 1.61 1.61 0 00-1.595 1.595c0 .841.725 1.595 1.595 1.595z",
    fill: "#fff"
  }));
}

var MemoSvgAttention = /*#__PURE__*/React.memo(SvgAttention);
var _default = MemoSvgAttention;
exports["default"] = _default;